export const PRICING_TIERS = ["FREE", "$", "$$", "$$$", "$$$$", "$$$$$", "CALL", "$?"];

export const PRICING_OPTIONS = [
  "FREE",
  "FREE-$",
  "FREE-$$",
  "FREE-$$$",
  "FREE-$$$$",
  "FREE-$$$$$",
  "FREE-CALL",
  "$",
  "$-$$",
  "$-$$$",
  "$-CALL",
  "$$",
  "$$-$$$",
  "$$-$$$$",
  "$$-CALL",
  "$$$",
  "$$$-$$$$$",
  "$$$-CALL",
  "$$$$",
  "$$$$$",
  "CALL",
  "$?",
];

export const PRICING_LABELS = {
  "FREE": "free / open-source",
  "$": "<$25/mo",
  "$$": "$25–99/mo",
  "$$$": "$100–499/mo",
  "$$$$": "$500–2,000/mo",
  "$$$$$": "$2,000+/mo (published)",
  "CALL": "contact sales / request demo",
  "$?": "pricing unknown",
};

export default function PricingLegend({ className = "" }) {
  return (
    <div
      className={`text-[12px] text-[#666] ${className}`}
      data-testid="pricing-legend"
    >
      <table className="tv-table" style={{ fontSize: 12 }}>
        <thead>
          <tr><th>tier</th><th>meaning</th></tr>
        </thead>
        <tbody>
          {PRICING_TIERS.map((t) => (
            <tr key={t}>
              <td className="font-bold whitespace-nowrap">{t}</td>
              <td>{PRICING_LABELS[t]}</td>
            </tr>
          ))}
          <tr>
            <td className="font-bold whitespace-nowrap">FREE-$$</td>
            <td>range — has a free tier; paid plans up to $99/mo</td>
          </tr>
          <tr>
            <td className="font-bold whitespace-nowrap">FREE-CALL</td>
            <td>range — free tier + an enterprise/contact-sales tier</td>
          </tr>
          <tr>
            <td className="font-bold whitespace-nowrap">$-$$$</td>
            <td>range — paid plans span $0–$499/mo</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
